/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from 'react';

import ChiTietModal from './components/ChiTietModal';

const UsersPage = () => {
  return (
    <>
      <div className='card card-xl-stretch mb-xl-9'>
        <ChiTietModal />
      </div>
    </>
  );
};

export default UsersPage;
